document.addEventListener("DOMContentLoaded", event => {
  const sliders = [...document.querySelectorAll(".scrollable-section")];

  for (let slider of sliders) {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", e => {
        isDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
        isDown = false;
    });

    slider.addEventListener("mouseup", () => {
        isDown = false;
        slider.classList.add("snap");
    });

    slider.addEventListener("mousemove", e => {
        if (!isDown) return;
        e.preventDefault();
        slider.classList.remove("snap");
        const x = e.pageX - slider.offsetLeft;
        const walk = x - startX;
        slider.scrollLeft = scrollLeft - walk;
    });
  }

  // SCROLLBAR
  const scrollContainers = [
    {
      element: document.getElementById('scroll-container-blog'),
      progressBar: document.getElementById('blog-progress-bar')
    },
    {
      element: document.getElementById('scroll-container-opinions'),
      progressBar: document.getElementById('opinions-progress-bar')
    }
  ]

  console.log(scrollContainers);
  
  if (scrollContainers.length === 0) return;

  function updateScrollProgress(container) {
    const scrollWidth = container.element.scrollWidth;
    const clientWidth = container.element.clientWidth;
    const scrollLeft = container.element.scrollLeft;
    
    const maxScroll = scrollWidth - clientWidth;
    const scrollPercentage = maxScroll > 0 
      ? (scrollLeft / maxScroll) * 100 
      : 0;
    
    container.progressBar.style.width = `${Math.min(scrollPercentage, 100)}%`;
  }

  function initScrollProgress() {
    scrollContainers.forEach(container => {
      updateScrollProgress(container);
      container.element.addEventListener('scroll', () => updateScrollProgress(container));
      window.addEventListener('resize', () => updateScrollProgress(container));
    });
  }

  initScrollProgress();
});